/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 立会者情報
 */
export interface Szoa308aResponseGasAceptSearchResultDtoTaiperInfo {
    /**
     * 立会有無フラグ：英数字<br>　コード変換マスターテーブル.画面項目ID「C001940」のユーザコードを設定
     */
    tatiaiEonflg?: string;
    /**
     * 立会有無フラグ名称：全半角混在
     */
    tatiaiEonflgAname?: string;
    /**
     * 立会者関係区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C401070」のユーザコードを設定
     */
    taiperRltdiv?: string;
    /**
     * 立会者関係区分名称：全半角混在
     */
    taiperRltdivAname?: string;
    /**
     * 立会者漢字氏名：全角
     */
    taiperName?: string;
    /**
     * 立会者電話番号コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C000010」のユーザコードを設定
     */
    taiperTeldv?: string;
    /**
     * 立会者電話番号コード名称：全半角混在
     */
    taiperTeldvAname?: string;
    /**
     * 立会者電話番号：半角
     */
    taiperTelNo?: string;
}

